import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { ToastContainer } from "react-toastify";
import "./i18n";
import { useTranslation } from "react-i18next";
import { COOKIES, LOCALSTORAGE } from "./utils/constants";
import LoaderS from "./components/Loader/Loader";
import { LoaderProvider } from "./utils/context/LoaderContext";

import { refreshToken, UpdateAccesToken } from "./utils/B2CLogin";
import { PATH } from "./utils/pagePath";
import { decryptData, encryptData } from "./utils/encryption_decryption";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./utils/B2BLogin";
import { MsalProvider } from "@azure/msal-react";
import * as Sentry from "@sentry/react";
import ErrorPage from "./pages/ErrorComponenet/ErrorPage";
import { Provider } from "react-redux";
import store from "./store/store";
import { DialogProvider } from "./hooks/dialogProvider";
import { PrimeReactProvider } from "primereact/api";
import { getString, setString } from "./utils/storage";

// Code Updated Dev - Shoaib, Requried for Error Logging!
Sentry.init({
  debug: false,
  dsn:
    globalThis._ENV_.REACT_APP_SENTRY_END_POINTS !== "local"
      ? globalThis._ENV_.REACT_APP_SENTRY_END_POINTS
      : undefined,
  environment: `${globalThis._ENV_.REACT_APP_ENV}`,
  integrations: [
    Sentry.linkedErrorsIntegration({
      limit: 7,
    }),
  ],
  tracesSampleRate: globalThis._ENV_.REACT_APP_ENV === "production" ? 0.1 : 1.0,
  profilesSampleRate: globalThis._ENV_.REACT_APP_ENV === "production" ? 0.1 : 1.0,
  beforeSend(event) {
    // Prevent sending events from localhost
    if (
      globalThis.location.hostname === "localhost" ||
      globalThis._ENV_.REACT_APP_SENTRY_END_POINTS === "local"
    ) {
      if (event.request?.headers) {
        delete event.request.headers["Authorization"];
        delete event.request.headers["Cookie"];
      }
      return null;
    }
    return event;
  },
});

type EnvProps = "production" | "development" | "local" | "uat"

const environment: EnvProps = globalThis._ENV_.REACT_APP_ENV  as EnvProps ?? "local"

if ( environment === "production" || environment === 'uat') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const msalInstance = new PublicClientApplication(msalConfig);
const useSetLanguage = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    const language = getString(`${LOCALSTORAGE?.LANGUAGE}`, false) || "EN";
    i18n.changeLanguage(language);
  }, [i18n]);
};
const AppWrapper = () => {
  useSetLanguage();
  useEffect(() => {
    // RefreshTokenFunc();
  }, []);

  const RefreshTokenFunc = async () => {
    if (globalThis.location.pathname !== "/login") {
      // let ref_tok_exists = cookies.get(COOKIES.REFERESH_TOKEN);
      let ref_tok_exists = getString(COOKIES.REFERESH_TOKEN, true);
     
      if (
        ref_tok_exists !== undefined &&
        ref_tok_exists !== null &&
        ref_tok_exists !== ""
      ) {
        let token_payload = {
          client_id: `${globalThis._ENV_.REACT_APP_TOKEN_CLIENT_ID}`,
          grant_type: "refresh_token",
          scope: "openid offline_access",
       
          refresh_token: ref_tok_exists,
        };

        let res = await refreshToken(token_payload);
        let userid = getString(LOCALSTORAGE?.USER_ID, true) ?? "";
        if (userid !== undefined && userid !== null && userid !== "") {
         
          setString(LOCALSTORAGE.ACCESS_TOKEN, res?.data?.id_token, true);

          setString(LOCALSTORAGE.REFERESH_TOKEN, res?.data?.refresh_token, true);

          if (res?.status === 200) {
            let update_tok_payload = {
              LOGIN_TYPE: "W",
              USER_ID: userid,
              TOKEN: res?.data?.id_token,
            };
            await UpdateAccesToken(update_tok_payload);
          } else {
            globalThis.location.href = PATH.LOGIN;
          }
        }
      } else {
      }
    }

    let timeoutId: NodeJS.Timeout;
    const refreshLoop = async () => {
      await RefreshTokenFunc();
      const timeout = Number(globalThis._ENV_.REACT_APP_REFRESH_TOKEN_TIME);
      timeoutId = setTimeout(refreshLoop, timeout);
    };
    refreshLoop();
    return () => {
      clearTimeout(timeoutId);
    };
  };

  return (
    // <LoaderProvider>
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Suspense fallback={<LoaderS />}>
        <DialogProvider>
          <RouterProvider router={router} fallbackElement={<ErrorPage />} />
        </DialogProvider>
      </Suspense>
    </>
    // </LoaderProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <MsalProvider instance={msalInstance}>
      <PrimeReactProvider>
        <AppWrapper />
            </PrimeReactProvider>
      </MsalProvider>
      {/* </PersistGate> */}
    </Provider>
  </Sentry.ErrorBoundary>
  // </React.StrictMode>
);

reportWebVitals();
